import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { Icon, type IconName } from '../icon/Icon';

export interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: IconName;
  /** Usually a `<Button>` that gets the player back to something useful. */
  action?: ReactNode;
  className?: string;
}

/** The empty/error pattern from the Figma "03 Patterns" page. */
export function EmptyState({ title, description, icon, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-md border border-border-subtle',
        'bg-bg-surface px-6 py-12 text-center',
        className,
      )}
    >
      {icon && <Icon name={icon} size={32} className="text-icon-muted" />}
      <p className="text-heading-s text-text-primary">{title}</p>
      {description && <p className="max-w-prose text-body-m text-text-secondary">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
